import deity1 from "../../../assets/images/deity1.jpeg";
import deityc5 from "../../../assets/images/deity5.jpeg";
import deityc6 from "../../../assets/images/deity6.jpeg";
// import deityc7 from "../../../assets/images/deityc7.jpg";
export const deityData = [
  {
    image: deity1,
    title: "The break-fast offering at 8:15 a.m.",
    description:
      "7 kinds of fruits, fruit juice, milk, dry fruits, halwa, sandesh and peda.",
    maintitle: "Sakalika Bhoga - ₹1001",
  },
  {
    image: deity1,
    title: "The afternoon offering at 4:00 p.m.",
    description: "7 kinds of fruits, fruit juice, cake, sandesh and peda.",
    maintitle: "Vaikalika Bhoga - ₹1001",
  },
  {
    image: deity1,
    title: "The late evening offering at 8:00 p.m.",
    description: "Chapati/puri, sabji, milk, halwa, sandesh and peda.",
    maintitle: "Shayana Bhoga - ₹2001",
  },
  {
    image: deity1,
    title: "The early morning offering at 4:00 a.m.",
    description:
      "Rasa-gulla, rasa-malai, peda, sandesh,rabri, condensed milk and sweet rice.",
    maintitle: "Balya Bhoga - ₹1501",
  },
  {
    image: deityc5,
    title: "The early evening offering at 6:30 p.m.",
    description:
      "Chapati/puri,4 kinds of sabjis, basmati rice, dhal, pakora, halwa, sandesh and peda.",
    maintitle: "Sandhya Bhoga - ₹2501",
  },
  {
    image: deityc6,
    title: "The noon offering",
    description:
      "Chapati/puri, 8 kinds of sabjis, basmati rice, dhal , pakora, salad, samosa, sweet samosa, sweet rice, sandesh and peda.",
    maintitle: "Raja Bhoga - ₹3500",
  },
  // {
  //   image: deityc7,
  //   title: "The break-fast offering at 8:15 a.m.",
  //   description:
  //     "This Seva includes all the services of the day like Balya Bhog, Sayan Bhog, Sakalika Bhog, Raj Bhog, Vaikalika Bhog, Sandhya Bhog, Sayan Bhog and pushpa seva.",
  //   maintitle: "manav",
  // },
];

export const deity = [
  "In this endeavour of offering service to Lord Krsna, you get eternal credit, and a little service offer to Lord Krsna can protect one from the most dangerous type of fear. --Bhagavad Gita 2.40",

  "While Krsna was going to the fruit vendor very hastily, most of the grains He was holding fell. Nonetheless, the fruit vendor filled Krsna’s hands with fruits, and her fruit basket was immediately filled with jewels and gold. --Srimad Bhagavatam 10.11.11",
  " Please grab the opportunity to attain supreme blessings by offering different bhoga and services to Sri Sri Radha Giridhariji and Sri Sri Jagannath, Baladeva, and Subhadra Ji.",
];
